import { UnitOfMeasure } from "../../pace-fns/pace-fns";

export type FieldChangeResult<T> = {
    data: T;
    valid: boolean;
  };

const isEmpty = (value: string) => (!value || value === "")

export const validateTimeField = (time: string): boolean => {

  if (isEmpty(time)) {
    return true;
  }
  const timeComponents = time.split(":");
  for (const timeComponent of timeComponents) {
    if (isNaN(Number(timeComponent))) {
      return false;
    }
  }
  return true;
};

export const validateDistanceField = (distance: string) =>  isEmpty(distance) || !isNaN(Number(distance));

export const validateUnitOfMeasureField = (unit: string): boolean => {
    return Object.values(UnitOfMeasure).includes(unit as UnitOfMeasure);
}

